import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { STRINGS } from '../data/strings';
import { PAGE_STRINGS } from '../data/strings.pages';
export type Lang = 'es' | 'en';
export type Localized<T> = Record<Lang, T>;
type LanguageContextValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (typeof STRINGS)['es'];
  p: (typeof PAGE_STRINGS)['es'];
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
const STORAGE_KEY = 'ymaf-lang';
function readInitialLang(): Lang {
  if (typeof window === 'undefined') return 'es';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === 'en' || stored === 'es' ? stored : 'es';
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>(readInitialLang);
  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang: setLangState,
    t: STRINGS[lang],
    p: PAGE_STRINGS[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-332" data-mp="2vy89239kflu0">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
}